import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=bbbefb3a&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=bbbefb3a&scoped=true&lang=css&"
import style1 from "./admin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbefb3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbbefb3a')) {
      api.createRecord('bbbefb3a', component.options)
    } else {
      api.reload('bbbefb3a', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=bbbefb3a&scoped=true&", function () {
      api.rerender('bbbefb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/admin.vue"
export default component.exports